export class Amount {
    getDps = (currency: string) => {
        if (['USD', 'JPY', 'CNY', 'CAD', 'HKD', 'CHF', 'EUR', 'GBP', 'KRW'].includes(currency)) return 2;
        if (['BTC', 'ETH', 'USDT', 'USDT-Trc20', 'USDT-Trc 20', 'USDT-Erc20', 'USDT-Erc 20', 'USDT-Omni'].includes(currency)) return 8;
        return 2;
    };

    formatDps = (currency: string, value: number | string) => {
        return Number(value).toFixed(this.getDps(currency));
    };
    // 向上取整
    formatCeil = (currency: string, value: number | string) => {
        const dps = this.getDps(currency);
        return Number(value) ? (Math.ceil(Number(value).mul(Math.pow(10, dps))).div(Math.pow(10, dps))).toFixed(dps) : Number(value).toFixed(dps);
    };

    /**
     * 小数位处理
     * @param value 传入值
     * @param num 保留位数
     * @param isFloor 不要四色五入，直接截取
     * @returns {string}
     */
    fixedNumber = (value: string | number, num: number = 2, isFloor: boolean = false) => {
        return isFloor
            ? Number(value).toFixed(num + 6).slice(0, -6)
            : Number(value).toFixed(num);
    };

    /**
     * 将金额逗号隔开
     * @param value
     * @param currency
     */
    formatCommas = (value: string | number, currency?: string) => {
        if (!value && value !== 0) return '';
        let res: string | number = value;
        if (currency) res = this.formatDps(currency, value);
        return res.toString().replace(/^\d+/g, (m) => m.replace(/(?=(?!^)(\d{3})+$)/g, ','));
    };

    /**
     * 计算总盈亏
     * @param profit
     * @param commission
     * @param storage
     * @param taxes
     */
    getTotalProfit = (profit: string, commission: string, storage: string, taxes: string) => {
        return Number(profit + taxes + storage + commission);
    };

    /**
     * 截断保留小数位
     */
    getTruncate = (value: string | number, currency: string = 'USD', fixed?: number) => {
        if (value.toString().indexOf('*') !== -1) return value;
        let str = value.toString();
        const num = fixed || this.getDps(currency && currency.toUpperCase().split('-')[0]);
        if (/\./.test(str)) {
            while (str.length <= str.indexOf('.') + num) str += '0';
            return str.slice(0, str.indexOf('.') + num + 1);
        } if (/\,/.test(str)) {
            const length = str.length;
            str = str + '.';
            while (str.length <= length + num) str += '0';
            return str.slice(0, length + num + 1);
        } else {
            return Number(value).toFixed(num);
        }
    };
}

export default new Amount();
